import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, FormLabel, ModalBody } from '@bonusly/design-system';

import { RescheduleDatePicker } from '../date-picker/reschedule-date-picker';

interface RescheduleModalBodyProps {
	availableRangeDays: number;
}

export const RescheduleModalBody: FC<RescheduleModalBodyProps> = ({ availableRangeDays }) => {
	const { t } = useTranslation('one_on_ones');

	return (
		<ModalBody pt={5} pb={0}>
			<Flex direction="column" gap={2}>
				<FormLabel color="text.default" fontSize={100} fontWeight="medium">
					{t('meeting.reschedule_modal.form.select_new_date')}
				</FormLabel>

				<RescheduleDatePicker availableRangeDays={availableRangeDays} />

				<FormLabel color="text.softest" fontSize={50} fontWeight="medium">
					{t('meeting.reschedule_modal.form.change_disclaimer')}
				</FormLabel>
			</Flex>
		</ModalBody>
	);
};
